import { is as ramdaIs } from 'ramda';
import _ from 'underscore';

import snapFunc from './snapsvg-path';

/* eslint-disable valid-typeof */
/* eslint-disable no-multi-assign */
/* eslint-disable prefer-rest-params */
/* eslint-disable no-prototype-builtins */
/* eslint-disable no-shadow */

// move item to the end of the array
const repush = (array, item) => {
    for (let i = 0, ii = array.length; i < ii; i++) {
        if (array[i] === item) {
            return array.push(array.splice(i, 1)[0]);
        }
    }
};

/*
 * Does o have the type
 * @sig is :: ({k:v}, String) -> Boolean
 */
const is = (o, type) => {
    type = type.toLowerCase();

    if (type === 'finite') return Number.isFinite(o);
    if (type === 'array') return Array.isArray(o);

    return (type === 'null' && o === null) || (type === typeof o && o !== null) || (type === 'object' && o === Object(o)) || Object.prototype.toString.call(o).slice(8, -1).toLowerCase() === type;
};

/*
 * Given a function f, a context and an optional postprocessor, memoize f -- but only up to 1000 results
 * If there's a postprocessor, it's called even if we had a cache hit
 * @sig cacher :: ((...a) -> b), *, b -> c) -> (...a) -> b
 */
const cacher = (f, context, postprocessor) => {
    function newf() {
        const arg = Array.prototype.slice.call(arguments, 0);
        const args = arg.join('\u2400');
        const cache = (newf.cache = newf.cache || {});
        const count = (newf.count = newf.count || []);

        if (cache.hasOwnProperty(args)) {
            repush(count, args);
            return postprocessor ? postprocessor(cache[args]) : cache[args];
        }

        if (count.length >= 1e3) delete cache[count.shift()];

        count.push(args);
        cache[args] = f.apply(context, arg);
        return postprocessor ? postprocessor(cache[args]) : cache[args];
    }

    return newf;
};

/*
 * Parses pathString into an array of arrays of command "Segments"
 *
 * @sig parsePathString :: String -> [Segment]
 *      Segment = [Command, ...Number]
 *      Command = String
 */
const parsePathString = pathString => {
    const pathCommand = /([a-z])[\s,]*((-?\d*\.?\d*(?:e[-+]?\d+)?[\s]*,?[\s]*)+)/gi;
    const pathValues = /(-?\d*\.?\d*(?:e[-+]?\d+)?)[\s]*,?[\s]*/gi;

    if (!pathString) return null;
    if (!ramdaIs(String, pathString)) throw new Error('pathString is not a string');

    const paramCounts = { a: 7, c: 6, o: 2, h: 1, l: 2, m: 2, r: 4, q: 4, s: 4, t: 2, v: 1, u: 3, z: 0 };
    const data = [];

    pathString.replace(pathCommand, (_, command, parameters) => {
        const params = [];
        let name = command.toLowerCase();

        // split up the parameters and put them into params
        parameters.replace(pathValues, (_, parameter) => parameter && params.push(+parameter));

        if (name === 'm' && params.length > 2) {
            data.push([command].concat(params.splice(0, 2)));
            name = 'l';
            command = command === 'm' ? 'l' : 'L';
        }

        if (name === 'o' && params.length === 1) data.push([command, params[0]]);
        if (name === 'r') data.push([command].concat(params));
        else {
            while (params.length >= paramCounts[name]) {
                data.push([command].concat(params.splice(0, paramCounts[name])));
                if (!paramCounts[name]) {
                    break;
                }
            }
        }
    });

    data.toString = toString;
    return data;
};

// snapsvg-path will attach things to ELement's prototype
function Element() {}

// snapsvg-path assumes Snap is public
global.Snap = {
    _,
    is,
    parsePathString,
};

snapFunc(global.Snap, Element, cacher);

const toCubic = global.Snap.path.toCubic;
const isPointInside = global.Snap.path.isPointInside;

export { toCubic, isPointInside };
